"use strict";
/**
 * @packageDocumentation
 * @module AttestedClaimUtils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decompress = exports.compress = exports.errorCheck = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("@kiltprotocol/utils");
const Attestation_utils_1 = tslib_1.__importDefault(require("../attestation/Attestation.utils"));
const RequestForAttestation_utils_1 = tslib_1.__importDefault(require("../requestforattestation/RequestForAttestation.utils"));
const AttestedClaim_1 = tslib_1.__importDefault(require("./AttestedClaim"));
/**
 *  Checks whether the input meets all the required criteria of an IAttestedClaim object.
 *  Throws on invalid input.
 *
 * @param input The potentially only partial IAttestedClaim.
 * @throws [[ERROR_ATTESTATION_NOT_PROVIDED]] or [[ERROR_RFA_NOT_PROVIDED]] when input's attestation and request respectively do not exist.
 * @throws [[ERROR_ATTESTEDCLAIM_UNVERIFIABLE]] when input's data could not be verified.
 *
 */
function errorCheck(input) {
    if (input.attestation) {
        Attestation_utils_1.default.errorCheck(input.attestation);
    }
    else
        throw utils_1.SDKErrors.ERROR_ATTESTATION_NOT_PROVIDED();
    if (input.request) {
        RequestForAttestation_utils_1.default.errorCheck(input.request);
    }
    else
        throw utils_1.SDKErrors.ERROR_RFA_NOT_PROVIDED();
    if (!AttestedClaim_1.default.verifyData(input)) {
        throw utils_1.SDKErrors.ERROR_ATTESTEDCLAIM_UNVERIFIABLE();
    }
}
exports.errorCheck = errorCheck;
/**
 *  Compresses an [[AttestedClaim]] object into an array for storage and/or messaging.
 *
 * @param attestedClaim An [[AttestedClaim]] that will be sorted and stripped for messaging or storage.
 *
 * @returns An ordered array of an [[AttestedClaim]] that comprises of an [[Attestation]] and [[RequestForAttestation]] arrays.
 */
function compress(attestedClaim) {
    errorCheck(attestedClaim);
    return [
        RequestForAttestation_utils_1.default.compress(attestedClaim.request),
        Attestation_utils_1.default.compress(attestedClaim.attestation),
    ];
}
exports.compress = compress;
/**
 *  Decompresses an [[AttestedClaim]] array from storage and/or message into an object.
 *
 * @param attestedClaim A compressed [[Attestation]] and [[RequestForAttestation]] array that is reverted back into an object.
 * @throws [[ERROR_DECOMPRESSION_ARRAY]] when attestedClaim is not an Array or it's length is unequal 2.
 *
 * @returns An object that has the same properties as an [[AttestedClaim]].
 */
function decompress(attestedClaim) {
    if (!Array.isArray(attestedClaim) || attestedClaim.length !== 2) {
        throw utils_1.SDKErrors.ERROR_DECOMPRESSION_ARRAY('Attested Claim');
    }
    return {
        request: RequestForAttestation_utils_1.default.decompress(attestedClaim[0]),
        attestation: Attestation_utils_1.default.decompress(attestedClaim[1]),
    };
}
exports.decompress = decompress;
exports.default = {
    decompress,
    compress,
    errorCheck,
};
